import { render, staticRenderFns } from "./chat-message-merchant-order.vue?vue&type=template&id=83d5be60&scoped=true"
import script from "./chat-message-merchant-order.vue?vue&type=script&lang=js"
export * from "./chat-message-merchant-order.vue?vue&type=script&lang=js"
import style0 from "./chat-message-merchant-order.vue?vue&type=style&index=0&id=83d5be60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d5be60",
  null
  
)

export default component.exports